<template>
  <div class="sl-tag-view">
    <sl-scroll ref="scroller">
      <Tag type="dot" v-for="(item, i) in tags" ref="tags" :key="item.name" :name="item.name" @on-close="close(item)" @click.native="link(item)" :closable="true" :color="item.name===currentPage ? 'primary':''"><!-- <Icon class="btn-refresh" :size="15" type="md-refresh" /> -->{{item.meta.title }}</Tag>
    </sl-scroll> 
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      tags:[]
    }
  },
  computed: {
    currentPage(){
      return this.$route.name
    }
  },
  created(){
  },
  mounted() {
    // 首次加载时将默认页面加入缓存
    this.add( this.$route )

    window.addEventListener('resize' , ()=>{
      // this.$nextTick(()=>{
      this.update()
      // })
    })
  },
  watch: {
    '$route' (to) {
      this.add( to )
    }
  },
  methods: {
    handlescroll(){

    },
    isActive(route){
      return route.path == this.$route.path
    },
    add(route){

      if(route.name){
        this.$store.dispatch('tagview/add',route);
      }

      this.update()
    },
    update(){
      let tags = this.$store.state.tagview.visited
      let index = tags.findIndex(i=>(this.$route.name==i.name))
      this.tags = tags
      this.$refs.scroller && this.$refs.scroller.scrollTo(index)
    },

    link(route){
      let obj = { name : route.name , params:null , query : null , meta:{ keepAlive:true} }
      if (route.params) {
        obj.params = route.params
      }
      if (route.query) {
        obj.query = route.query
      }

      if( route.name == this.$route.name){
         this.refresh( this.$route )
      }else{
        // if( this.$keepAlive.has(route.name) ){
        this.$keepAlive.refresh(route.name)
        // }

        this.$router.push( obj )

      }
    },

    refresh(route){
      let component = route.matched[route.matched.length - 1]
      if(component && component.instances.default){
        let instance = component.instances.default
        if('$update' in instance){
          instance.$update()
        }
      }
    },

    close(route){

      if(!(this.tags.length == 1 && route.name == 'dashboard')){
        this.$store.dispatch('tagview/remove',route).then((views)=>{
          //处理 关闭当前标签
          if(this.isActive(route)){
            let lastView = views.slice(-1)[0]//选取路由数组中的最后一位
            if(lastView){
              this.link( lastView )
            }else{
              this.$router.push('/');
            }
          }
        })
      }
      
    }
  }

}

</script>
<style lang='scss'>
  .sl-tag-view{
    background:#fff;
    .btn-refresh{
      display:none;
      margin-right:8px;
      top:-1px;
      position: relative;
    }

    .cur {
      .ivu-tag-dot-inner{
        display:none;
      }
      .btn-refresh{
        display:inline-block;
      }

      &:hover{
        .btn-refresh{
          color:#2d8cf0;
        }
      }
    }
  }
</style>
